const BASELESS_URI_ERROR = "loadGltf: baseless input can't resolve relative URI; use self-contained GLB or URL with base.";
function resolveBufferUri(uri, baseUrl) {
  if (baseUrl) {
    return new URL(uri, baseUrl + "x").href;
  }
  try {
    return new URL(uri) + "";
  } catch {
    throw new Error(BASELESS_URI_ERROR);
  }
}

export { resolveBufferUri };
//# sourceMappingURL=gltf-uri.js.map
